// FNP-533: form-shape Zod schema for the BillableEvents filter (read-only module).
import {z} from 'zod';

// FNP-1879: channel and the day bounds only reach the API together, through
// listBillableEventsByChannelAndDay(channel!, dayStart!, dayEnd!). BillableEventsFilterInput
// has no channel and no day fields, so a channel alone (or a day bound without one) used to
// be dropped silently by fetchRecords while the filter badge still counted it. Refuse the
// combination here instead, where the operator can see why.
const CHANNEL_DAY_MESSAGE = 'Channel, Day Start and Day End must be set together';

export const FilterFormSchema = z.object({
    state: z.string().optional(),
    channel: z.string().optional(),
    customerId: z.string().optional(),
    dayStart: z.string().optional(),
    dayEnd: z.string().optional(),
}).superRefine((values, ctx) => {
    const fields = ['channel', 'dayStart', 'dayEnd'] as const;
    const set = fields.filter(field => Boolean(values[field]));
    if (set.length === 0 || set.length === fields.length) {
        return;
    }
    fields.filter(field => !values[field]).forEach(field => {
        ctx.addIssue({code: z.ZodIssueCode.custom, path: [field], message: CHANNEL_DAY_MESSAGE});
    });
});
